document.addEventListener('DOMContentLoaded', function() {
    const offerElement = document.querySelector('.make-an-offer');
    const offerButton = offerElement.querySelector('button');
    const modal = document.getElementById('offerModal');
    const closeModal = modal.querySelector('.close');
    const submitOfferButton = document.getElementById('submitOffer');
    const offerPriceInput = document.getElementById('modal-offer-price');
    let regularPrice = parseFloat(modal.getAttribute('data-regular-price'));
    
    const quantityInput = document.getElementById('modal-quantity');
    const variantId = offerElement.getAttribute('data-variant-id');

    const emailInput = document.getElementById('modal-email');

    // Listen for variant changes
    document.addEventListener('product:variant-change', function(event) {
        if (event.detail && event.detail.variant) {
            // Update the regular price when variant changes
            regularPrice = event.detail.variant.price / 100;
            modal.setAttribute('data-regular-price', regularPrice);
            
            // If min offer price is calculated, update it
            if (offerPriceInput) {
                const minOfferPrice = regularPrice * 0.8; // 80% of the regular price
                // Update validation if needed
                const value = parseFloat(offerPriceInput.value);
                if (!isNaN(value) && value >= regularPrice) {
                    offerPriceInput.setCustomValidity(`Offer price should be less than the asking price of $${regularPrice}.`);
                } else if (!isNaN(value) && value < minOfferPrice) {
                    offerPriceInput.setCustomValidity(`Offer cannot be less than 80% of the current price of $${regularPrice} ($${minOfferPrice.toFixed(0)})`);
                }
                offerPriceInput.reportValidity();
            }
        }
    });

    function isValidEmail(email) {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailPattern.test(email);
    }

    function isValidNum(value) {
        return value && !isNaN(value) && value > 0;
    }

    function updateTotalPrice() {
        const offerPriceValue = offerPriceInput.value;
        const quantityValue = quantityInput.value;
        
        let offerPrice = isValidNum(offerPriceValue) ? parseFloat(offerPriceValue) : " Your Offer";
        let quantity = isValidNum(quantityValue) ? parseInt(quantityValue, 10) : "Quantity";

        let total_price = isValidNum(offerPriceValue) && isValidNum(quantityValue) ? (offerPrice * quantity) : "Total Price";
        let displayMessage = `${quantity} x $${offerPrice} = $${total_price}`;
    
        totalPriceDisplay.textContent = displayMessage;
    }

    const minOfferPrice = regularPrice * 0.8; // 80% of the regular price

    offerPriceInput.addEventListener('input', function() {
        const value = parseFloat(offerPriceInput.value);
        if (value <= 0) {
            offerPriceInput.setCustomValidity("Offer price must be greater than 0.");
        } else if (isNaN(value)) {
            offerPriceInput.setCustomValidity("Please enter a valid number.");
        } else if (value >= regularPrice) {
            offerPriceInput.setCustomValidity(`Offer price should be less than the asking price of $${regularPrice}.`);
        } else if (value < minOfferPrice) {
            offerPriceInput.setCustomValidity(`Offer cannot be less than 80% of the current price of $${regularPrice} ($${minOfferPrice.toFixed(0)})`);
        } else {
            offerPriceInput.setCustomValidity(""); // Clear custom validity message
        }

        offerPriceInput.reportValidity() // trigger validation message
        updateTotalPrice();
    });

    quantityInput.addEventListener('input', function() {
        const value = parseFloat(quantityInput.value);
        if (value <= 0) {
            quantityInput.setCustomValidity("Quantity must be greater than 0.");
        } else if (isNaN(value)) {
            quantityInput.setCustomValidity("Please enter a valid number.");
        } else if (value >= regularPrice) { // inventory check
            quantityInput.setCustomValidity(`This item has X in stock $${regularPrice}.`);
        } else {
            quantityInput.setCustomValidity(""); // Clear custom validity message
        }

        quantityInput.reportValidity() // trigger validation message
        updateTotalPrice();
    });


    quantityInput.addEventListener('input', updateTotalPrice); // Add listener for quantity input

    // Function to open the modal
    function openModal() {
        modal.style.display = 'block';
    }

    // Function to close the modal
    function closeModalFunction() {
        modal.style.display = 'none';
    }

    // Open the modal when the "Make Offer" button is clicked
    offerButton.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent any default action
        openModal();
    });

    // Close the modal when the close button is clicked
    closeModal.addEventListener('click', closeModalFunction);

    // Also close the modal if the user clicks outside of it
    window.addEventListener('click', function(event) {
        if (event.target == modal) {
            closeModalFunction();
        }
    });

    const successMessage = document.createElement("div"); // Create a success message element
    successMessage.className = "success-feedback"; // Assign class for styling
    successMessage.style.display = "none"; // Initially hide the success message
    document.body.appendChild(successMessage); // Append it to the body or a specific container

    // Handle form submission within the modal
    submitOfferButton.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent form submission

        // Show loading animation and disable the submit button
        submitOfferButton.disabled = true;
        submitOfferButton.innerHTML = '<div class="loading-animation"></div>'; // Your loading animation
        submitOfferButton.style.display = 'inline-flex'; // Make the button a flex container
        submitOfferButton.style.justifyContent = 'center'; // Center content horizontally
        submitOfferButton.style.alignItems = 'center'; // Center content vertically

        let isFormValid = true;
        // Check consent checkbox
var consentCheckbox = document.getElementById('offer-consent');
if (consentCheckbox && !consentCheckbox.checked) {
    consentCheckbox.setCustomValidity("Please confirm you’re ready to complete payment within 24 hours.");
    consentCheckbox.reportValidity();
    isFormValid = false;
} else if (consentCheckbox) {
    consentCheckbox.setCustomValidity(""); // clear if checked
}


        if (emailInput) {
            if (!isValidEmail(emailInput.value)) {
                emailInput.setCustomValidity("Please enter a valid email address.");
                emailInput.reportValidity();
                isFormValid = false;
            } else {
                emailInput.setCustomValidity(""); // Clear custom validity message
            }
        }

        if (!offerPriceInput.checkValidity()) {
            offerPriceInput.reportValidity();
            isFormValid = false;
        }

        if (!quantityInput.checkValidity()) {
            quantityInput.reportValidity();
            isFormValid = false;
        }

        // Perform validation
        if (isFormValid) {
            const endpoint = "https://sell.bazaa.com.au/api/public/make-an-offer";
            console.log('emailInput', emailInput?.value);
            console.log('amplitudeShopify', window?.amplitudeShopify?.customer?.email);
            console.log('offerPriceInput', offerPriceInput.value);
            console.log('quantityInput', quantityInput.value);
            console.log('variantId', variantId);
            const data = {
                email: emailInput?.value || window?.amplitudeShopify?.customer?.email || '',
                amount: parseFloat(offerPriceInput.value),
                quantity: parseInt(quantityInput.value, 10),
                variantId: parseInt(variantId, 10)
            };

            fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify(data),
            })
            .then(response => {
                if (response.status === 204 || response.ok) {
                    return { success: true };
                }
                // Handle error responses
                if (!response.ok) {
                    return response.json().then(errorData => {
                        throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
                    }).catch(() => {
                        // If JSON parsing fails, throw generic error
                        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
                    });
                }
                return response.json();
            })
            .then(data => {
                if (data.error) {
                    throw new Error(data.error);
                }
                // Update submit button to match Bazaa branding after success
                submitOfferButton.innerHTML = 'Offer submitted'; // Unicode check mark
                submitOfferButton.style.backgroundColor = '#000';        // Bazaa black
                submitOfferButton.style.color = '#fff';                  // White text
                submitOfferButton.style.border = '1px solid #000';       // Keep shape consistent
                submitOfferButton.style.opacity = '1';                   // Full visibility
                submitOfferButton.style.fontWeight = '700';              // Bold like other buttons
                submitOfferButton.style.letterSpacing = '0.5px';         // Slight tracking for polish
                submitOfferButton.style.transition = 'all 0.3s ease';    // Smooth change

                // Close the modal after 3 seconds
                setTimeout(() => {
                    closeModalFunction(); // Close the modal
                    submitOfferButton.disabled = false; // Re-enable the submit button
                    submitOfferButton.innerHTML = 'Submit Offer'; // Reset button text
                    submitOfferButton.style.backgroundColor = ''; // Reset button background
                    submitOfferButton.style.color = ''; // Reset button text color
                }, 10000);
            })
            .catch((error) => {
                console.error('Error:', error);
                submitOfferButton.disabled = false; // Re-enable the submit button
                submitOfferButton.innerHTML = 'Submit Offer'; // Reset button text to original
            });
        } else {
            // Trigger validation messages for the user
            offerPriceInput.reportValidity();
            quantityInput.reportValidity();
            submitOfferButton.disabled = false; // Re-enable the submit button if form is invalid
            submitOfferButton.innerHTML = 'Submit Offer'; // Reset button text
        }
    });
});

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.btn.button.dynamic-checkout')) {
        document.querySelector('.btn.button.dynamic-checkout').addEventListener('click', function(e) {
            e.preventDefault();
            
            // Get vendor ID from data-vendor attribute
            const vendorId = e.target.getAttribute('data-vendor');
            
            // Get quantity from .add_to_cart_holder input
            const quantity = parseInt(document.querySelector('.add_to_cart_holder input').value, 10);
            
            // Form the final URL
            const finalUrl = `${window.custom_cart_endpoint}/cart?listings=${vendorId}&quantities=${quantity}`;
            // Redirect to the final URL
            window.location.href = finalUrl;
        });
    }
});
